import { NavLink } from 'react-router-dom'

import { sportChipActiveClass, type SportKey } from '../utils/sportTheme'

const ADMIN_CHIPS: ReadonlyArray<{ to: string; label: string; end?: boolean }> = [
  { to: '/admin/ps-ratings/adjust', label: 'Adjust Pre-Season Ratings', end: true },
  { to: '/admin/ps-ratings/audit', label: 'Pre-Season Ratings Audit Log' },
]

const CHIP_INACTIVE =
  'bg-white/90 text-slate-600 shadow-sm ring-1 ring-slate-200/70 hover:bg-white hover:text-slate-900 hover:shadow'

interface Props {
  sport?: SportKey
}

export function AdminTertiaryNav({ sport = 'mlb' }: Props) {
  const activeClass = sportChipActiveClass(sport)

  return (
    <nav className="flex flex-wrap gap-2" aria-label="Admin sections">
      {ADMIN_CHIPS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end ?? false}
          className={({ isActive }) =>
            [
              'rounded-full px-3.5 py-1.5 text-sm font-medium transition',
              isActive ? activeClass : CHIP_INACTIVE,
            ].join(' ')
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  )
}
